import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import { csrfToken } from '../../../../configs/axios';

const SocialForm = ({ link, formId, socialName, iconClass }) => (
  <form id={formId} method="post" action={link}>
    <input type="hidden" name="authenticity_token" value={csrfToken} />
    <button
      type="submit"
      className="hms-btn hms-btn--lg hms-btn--secondary"
      data-ga-category="Login"
    >
      <span className={cx('social-img', iconClass)} />
      Sign in with {socialName}
    </button>
  </form>
);

SocialForm.propTypes = {
  link: T.string.isRequired,
  formId: T.string.isRequired,
  socialName: T.string.isRequired,
  iconClass: T.string.isRequired,
};

export default SocialForm;
